// OmegaCard.jsx

import React from "react";
import BasePackageCard from "./BasePackageCard";
import { OMEGA } from "../../../../constants";
import { useTranslation } from "../../../../language";

export default function OmegaCard() {
  const { t } = useTranslation();

  const panel = {
    id: "omega",
    title: t("card_omega_title"),
    subtitle: t("card_omega_desc"),
    biomarkers: t("card_omega_markers"),
    price: "€ 99",
    image: OMEGA,
  };

  return <BasePackageCard panel={panel} />;
}